import React from 'react';

import { useCurrentuser } from '@uplift/contexts';
import { Loader, ProviderLayout, ReviewLayout } from '@uplift/ui-v2';
import { DocumentsList } from './DocumentsList';
import { DocumentPreview } from './DocumentPreview';
import { DocumentLayout } from './DocumentPreview/components';
import { useProviderDocumentsQuery } from '@uplift/queries';


export const DocumentsCenterPageContent: React.VFC = () => {
  const me = useCurrentuser();
  const { data: documents = [] } = useProviderDocumentsQuery(me.id);
  const [ selectedDocumentId, setSelectedDocumentId ] = React.useState<string | null>(null);
  const selectedDocument = documents.find(d => d.id === selectedDocumentId) ?? documents[0] ?? null;

  return (
    <ReviewLayout
      sidebarWidth="350px"
      minSidebarWidth="300px"
      sidebar={(
        <DocumentsList
          documents={documents}
          selectedDocumentId={selectedDocument?.id}
          onSelectDocument={(documentId) => {
            setSelectedDocumentId(documentId);
          }}
        />
      )}
      content={selectedDocument && (
        <React.Suspense fallback={(
          <DocumentLayout
            title=" "
            subtitle=" "
          >
            <Loader minHeight={300} color="secondary" />
          </DocumentLayout>
        )}
        >
          <DocumentPreview
            document={selectedDocument}
            setSelectedDocumentId={setSelectedDocumentId}
          />
        </React.Suspense>
      )}
    />
  );
};

export const DocumentsCenterPage: React.FC = () => {
  return (
    <ProviderLayout>
      <DocumentsCenterPageContent />
    </ProviderLayout>
  );
};
